module.exports = __webpack_public_path__ + "media/categories/1039-36391536.svg";